module.exports = __webpack_public_path__ + "media/images/lane/collapse-close-1cebcf4ce8186938dce1c20cea039a5e.png";